import { Link, useLoaderData, useRevalidator } from 'react-router-dom'
import { UserRoleGroup } from './components/user-role-group'
import { Form, Formik } from 'formik'
import { useUpdatePermissionsMutation } from '@/store/services'
import { Button } from '@material-tailwind/react'
import { list } from '@/router/utils'
import { useTranslation } from 'react-i18next'
import { useAuthorization } from '@/hooks'
import { useEffect } from 'react'

export const UserRoleEdit = () => {
  const { hasAccess } = useAuthorization({
    redirection: {
      enable: true
    }
  })
  const [role = {}, availableActions = []] = useLoaderData()
  const { t } = useTranslation()
  const [updatePermissions, { isLoading }] = useUpdatePermissionsMutation()
  const currentRole = role.role
  const klassKeys = Object.keys(availableActions)
  const permissions = currentRole.permissions
  const revalitador = useRevalidator()

  const onSubmit = async (permissions) => {
    const newPermissions = permissions.map((permission) => {
      return {
        id: permission.id,
        actions: permission.actions
      }
    })
    try {
      await updatePermissions(newPermissions).unwrap()
      revalitador.revalidate()
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    hasAccess('permission#update')
  }, [])

  return (

    <Formik initialValues={permissions} onSubmit={onSubmit} enableReinitialize>

      <Form>
        <div>
          {klassKeys.filter(klass => klass !== 'Import').map((klassKey) => (
            <UserRoleGroup
              key={klassKey}
              klassKey={klassKey}
              defaultActions={availableActions[klassKey]}
            />
          ))
          }
          {
            <UserRoleGroup
              key={'Import'}
              klassKey={'Import'}
              defaultActions={availableActions.Import}
              title='Carga masiva'
              description='El perfil puede hacer cargas masivas'
            />
          }
        </div>

        <div className='flex justify-end gap-3 mt-10'>
          <Link to={list('users')}>
            <Button variant='text' type='submit'>
              {t('actions.cancel')}
            </Button>
          </Link>

          <Button type='submit' loading={isLoading}>
            {t('actions.update.one')}
          </Button>
        </div>
      </Form>
    </Formik>
  )
}
